<div class="modal fade vehicle-remarks-modal" id="kt_modal_vehicle_remarks" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Vehicle Remark</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body p-5">
        <!-- Vehicle Information -->
        <div class="row mb-5" *ngIf="selectedVehicle">
          <div class="col-12">
            <div class="bg-light-primary p-3 rounded">
              <h5 class="fw-bold text-primary mb-2">Vehicle Information</h5>
              <div class="row">
                <div class="col-md-6">
                  <span class="fw-bold">Vehicle:</span> {{ selectedVehicle.company_name }} {{ selectedVehicle.name }}
                </div>
                <div class="col-md-6">
                  <span class="fw-bold">Car Number:</span> {{ selectedVehicle.car_no || 'N/A' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Add Remark Form -->
        <form [formGroup]="remarkForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="row">
            <!-- Vehicle Remark -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Vehicle Remark</label>
              <textarea
                class="form-control"
                formControlName="vehicle_remark"
                rows="4"
                placeholder="Enter vehicle remark"
                [class.is-invalid]="vehicle_remark?.invalid && vehicle_remark?.touched">
              </textarea>
              <div class="invalid-feedback" *ngIf="vehicle_remark?.invalid && vehicle_remark?.touched">
                <div *ngIf="vehicle_remark?.errors?.['required']">Vehicle remark is required</div>
              </div>
            </div>

            <!-- Spare Key/Part Info -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Spare Key/Part Info</label>
              <textarea
                class="form-control"
                formControlName="spare_key_part_info"
                rows="4"
                placeholder="Enter spare key/part info">
              </textarea>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="row">
            <div class="col-12 text-center">
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="isLoading">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Save
              </button>
            </div>
          </div>
        </form>

        <!-- Remarks List -->
        <div class="row mt-8">
          <div class="col-12">
            <h5 class="fw-bold mb-4">Vehicle Remarks History</h5>

            <!-- Loading State -->
            <div *ngIf="isLoadingRemarks" class="text-center py-3">
              <div class="d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Loading remarks...
              </div>
            </div>

            <!-- No Data State -->
            <div *ngIf="!isLoadingRemarks && vehicleRemarks.length === 0" class="text-center py-3">
              <div class="text-muted">No remarks found for this vehicle</div>
            </div>

            <!-- Remarks Table -->
            <div *ngIf="!isLoadingRemarks && vehicleRemarks.length > 0" class="table-responsive">
              <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                <thead>
                  <tr class="fw-bold text-muted bg-light">
                    <th class="ps-4 min-w-100px">Delete</th>
                    <th class="min-w-100px">Date</th>
                    <th class="min-w-200px">Message</th>
                    <th class="min-w-150px">Spare Key/Part Info</th>
                    <th class="min-w-100px">Remark By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let remark of vehicleRemarks; trackBy: trackByFn">
                    <td class="ps-4">
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        (click)="deleteRemark(remark)"
                        title="Delete Remark">
                        <i class="ki-duotone ki-trash fs-6">
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                          <span class="path4"></span>
                          <span class="path5"></span>
                        </i>
                      </button>
                    </td>
                    <td>
                      <div class="text-dark fw-bold text-hover-primary fs-6">
                        {{ remark.created_at | date:'dd-MM-yy' || '-' }}
                      </div>
                      <div class="text-muted fs-7">
                        {{ remark.created_at | date:'HH:mm JST' || '-' }}
                      </div>
                    </td>
                    <td>
                      <div class="text-dark fw-bold">
                        {{ remark.vehicle_remark || '-' }}
                      </div>
                    </td>
                    <td>
                      <div class="text-dark">
                        {{ remark.spare_key_part_info || '-' }}
                      </div>
                    </td>
                    <td>
                      <div class="text-dark">
                        {{ remark.created_by?.name || 'Chaudhary Plant' }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
